<template>
	<div class="default-widget-field disable-fields">
		<transition name="fromLeft">
			<div v-if="titleEnabled && !hideTitle" class="default-widget-field-title">
				{{ titleValueLocal || 'Title' }}
			</div>
		</transition>

		<transition name="fromLeft">
			<div v-if="descriptionEnabled" class="widget-description">
				{{ descriptionValueLocal || 'Description' }}
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'DefaultWidgetField',
	props: {
		titleValue: { type: String },
		titleEnabled: { type: Boolean },
		descriptionValue: { type: String },
		descriptionEnabled: { type: Boolean },
		hideTitle: { type: Boolean, default: false },
	},
	computed: {
		titleValueLocal: {
			set(value) {
				this.$emit('update:titleValue', value);
			},
			get() {
				return this.titleValue;
			},
		},
		descriptionValueLocal: {
			set(value) {
				this.$emit('update:descriptionValue', value);
			},
			get() {
				return this.descriptionValue;
			},
		},
	},
};
</script>
<style scoped lang="scss">
.default-widget-field {
	overflow-wrap: break-word !important;

	.default-widget-field-title {
		padding-bottom: 4px;
		font-family: Poppins;
		font-size: 16px;
		font-weight: 400;
		color: #303133;
	}

	.widget-description {
		padding-bottom: 3px;
		font-family: Poppins;
		font-size: 12px;
		font-weight: 400;
		color: #9e9e9e;
	}
}
</style>
